{
  "title": "如何查詢平台稽核紀錄",
  "description": "查詢整個平台範圍的操作稽核紀錄，依操作者、對象、競賽或時間篩選。",
  "headings": ["你會完成什麼", "適用角色", "操作前確認", "操作步驟", "完成後", "常見問題"],
  "summary": "完成後，您可以查到平台上具敏感性的操作紀錄，包含操作者、時間、對象與原因。",
  "roleNote": "平台管理員",
  "prerequisites": ["具備平台稽核紀錄查詢權限"],
  "pathLabel": "平台管理 → 稽核紀錄",
  "steps": [
    {
      "title": "1. 開啟稽核紀錄清單",
      "description": "清單依時間新到舊排序，為伺服器端分頁，不會一次載入全平台歷史紀錄。"
    },
    {
      "title": "2. 依需要篩選",
      "description": "可依操作者（actor）、受影響使用者（target user）、所屬競賽、操作類型（action），以及起訖時間範圍篩選，可多條件併用。"
    },
    {
      "title": "3. 查看單筆紀錄內容",
      "description": "每筆紀錄包含操作類型、對象類型與名稱（若該類型有名稱，例如隊伍、競賽、使用者；表單或輪次等無名稱的類型則為空）、所屬競賽（若有）、操作者的顯示名稱／Email、操作時間，以及原因（若該操作要求填寫原因）。與寄信相關的動作也會列入，例如「以 Email 寄送了公告」「傳送了報名資料補填提醒」，以及「系統寄出了通知信」（記錄晉級、作品退回、資格驗證未通過與評審邀請的寄送成功與失敗數，不含 Email 位址）。"
    }
  ],
  "afterward": [
    "可依此清單追蹤敏感操作（如停權、撤銷權限、鎖定與公布結果、修改截止時間等）的完整歷史"
  ],
  "nextSteps": "若需要處理特定使用者的異常，可搭配「如何管理平台使用者」進一步查看該使用者的帳號狀態並採取行動。",
  "faq": [
    {
      "q": "稽核紀錄裡的操作者角色，是操作當下的角色還是現在的角色？",
      "a": "是操作者目前的角色，不是操作當下的角色快照。稽核紀錄本身不記錄操作者當時的角色，因此若該操作者事後被升級或降級，歷史紀錄呈現的角色標籤會反映今天的狀態，而非事發當時的狀態。"
    },
    {
      "q": "每一筆稽核紀錄都有填寫原因嗎？",
      "a": "不一定。只有系統要求該操作必須填寫原因時（例如停權帳號、退回或拒絕競賽申請）才會有原因內容；沒有要求原因的操作，此欄位為空。"
    },
    {
      "q": "稽核紀錄可以被修改或刪除嗎？",
      "a": "不行。稽核紀錄查詢介面本身完全唯讀，系統沒有提供任何修改或刪除既有稽核紀錄的操作，確保稽核歷史的完整性。"
    }
  ]
}
